import { RegisterTemplate } from "../../components/templates/Register"

export function Component() {
  return <RegisterTemplate />
}
